import { switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '../../../../shared/services/api-service/api-service';

@Injectable()
export class ShelterProfileDataService {
  private studentCache = {};

  constructor(public apiService: ApiService) {}

  getProfileData$(caresId: string, shelterId: string): Observable<any> {
    const payload = this.getShelterProfileQuery(caresId, shelterId);

    if (this.studentCache[caresId]) return of(this.studentCache[caresId]);

    return this.apiService.getStudentsGraphQL(payload).pipe(
      switchMap(({ data: { ShelterGridData: studentData } }) => studentData),
      tap(studentData => (this.studentCache[studentData.CARES_ID] = studentData)),
    );
  }

  getShelterProfileQuery(caresId: string, shelterId: string) {
    const query = `{
      ShelterGridData(
        shelterId: "${shelterId}"
        gridType: "attGrid"
        columns: [
         "COUNT_OF_LATENESSES_MON"
         "COUNT_OF_LATENESSES_TUES"
         "COUNT_OF_LATENESSES_WED"
         "COUNT_OF_LATENESSES_THURS"
         "COUNT_OF_LATENESSES_FRI"
         "COUNT_OF_ABSENCES_MON"
         "COUNT_OF_ABSENCES_TUES"
         "COUNT_OF_ABSENCES_WED"
         "COUNT_OF_ABSENCES_THURS"
         "COUNT_OF_ABSENCES_FRI"
         "SCHOOL_PRINCIPAL_EMAIL"
         "SCHOOL_PRINCIPAL_NAME"
         "CONSECUTIVE_ABSENCES"
         "CONSECUTIVE_LATENESS"
         "CURR_YTD_ATT"
         "OVERALL_ATTENDANCE_1_YEAR_PRIOR"
         "OVERALL_ATTENDANCE_2_YEAR_PRIOR"
         "SEPT_ATTENDANCE_CURR_SY"
         "OCT_ATTENDANCE_CURR_SY"
         "NOV_ATTENDANCE_CURR_SY"
         "DEC_ATTENDANCE_CURR_SY"
         "JAN_ATTENDANCE_CURR_SY"
         "FEB_ATTENDANCE_CURR_SY"
         "MAR_ATTENDANCE_CURR_SY"
         "APR_ATTENDANCE_CURR_SY"
         "MAY_ATTENDANCE_CURR_SY"
         "JUNE_ATTENDANCE_CURR_SY"
         "SEPT_ATTENDANCE_1_YEAR_PRIOR"
         "OCT_ATTENDANCE_1_YEAR_PRIOR"
         "NOV_ATTENDANCE_1_YEAR_PRIOR"
         "DEC_ATTENDANCE_1_YEAR_PRIOR"
         "JAN_ATTENDANCE_1_YEAR_PRIOR"
         "FEB_ATTENDANCE_1_YEAR_PRIOR"
         "MAR_ATTENDANCE_1_YEAR_PRIOR"
         "APR_ATTENDANCE_1_YEAR_PRIOR"
         "MAY_ATTENDANCE_1_YEAR_PRIOR"
         "JUNE_ATTENDANCE_1_YEAR_PRIOR"
         "SEPT_ATTENDANCE_2_YEAR_PRIOR"
         "OCT_ATTENDANCE_2_YEAR_PRIOR"
         "NOV_ATTENDANCE_2_YEAR_PRIOR"
         "DEC_ATTENDANCE_2_YEAR_PRIOR"
         "JAN_ATTENDANCE_2_YEAR_PRIOR"
         "FEB_ATTENDANCE_2_YEAR_PRIOR"
         "MAR_ATTENDANCE_2_YEAR_PRIOR"
         "APR_ATTENDANCE_2_YEAR_PRIOR"
         "MAY_ATTENDANCE_2_YEAR_PRIOR"
         "JUNE_ATTENDANCE_2_YEAR_PRIOR"
         "PAST_10_ATT"
         "PAST_20_ATT"
         "ATTENDANCE_THIS_TERM"
         "ABSENCES_YTD"
         "SHELTER_UNIT"
         "SHELTER_FACILITY_NAME"
         "SHELTER_ADMIT_DATE"
         "SHELTER_ELIGIBILITY_OUTCOME"
         "CARES_FAMILY_ID"
         "HOUSING_STATUS"
         "TEMP_HOUSING_FLAG"
         "HOME_ADDRESS_PREVIOUS_TO_SHELTER"
         "STUDENT_NAME_FIRST_LAST"
         "SHELTER_OSIS_NUMBER"
         "CARES_ID"
         "SCHOOL_NAME"
         "CLASS"
         "SHELTER_GRADE"
         "SHELTER_AGE"
         "IS_SPED"
         "IS_ELL"
         "SHELTER_SCHOOL_DBN"
         "SCHOOL_PHONE"
         "ADMIT_DATE"
         "TRANSIT_TIME"
         "TRANSIT_DISTANCE"
        ]
        caresIds: ["${caresId}"]
      ) {
        COUNT_OF_LATENESSES_MON
        COUNT_OF_LATENESSES_TUES
        COUNT_OF_LATENESSES_WED
        COUNT_OF_LATENESSES_THURS
        COUNT_OF_LATENESSES_FRI
        COUNT_OF_ABSENCES_MON
        COUNT_OF_ABSENCES_TUES
        COUNT_OF_ABSENCES_WED
        COUNT_OF_ABSENCES_THURS
        COUNT_OF_ABSENCES_FRI
        SCHOOL_PRINCIPAL_EMAIL
        SCHOOL_PRINCIPAL_NAME
        CONSECUTIVE_ABSENCES
        CONSECUTIVE_LATENESS
        CURR_YTD_ATT
        OVERALL_ATTENDANCE_1_YEAR_PRIOR
        OVERALL_ATTENDANCE_2_YEAR_PRIOR
        SEPT_ATTENDANCE_CURR_SY
        OCT_ATTENDANCE_CURR_SY
        NOV_ATTENDANCE_CURR_SY
        DEC_ATTENDANCE_CURR_SY
        JAN_ATTENDANCE_CURR_SY
        FEB_ATTENDANCE_CURR_SY
        MAR_ATTENDANCE_CURR_SY
        APR_ATTENDANCE_CURR_SY
        MAY_ATTENDANCE_CURR_SY
        JUNE_ATTENDANCE_CURR_SY
        SEPT_ATTENDANCE_1_YEAR_PRIOR
        OCT_ATTENDANCE_1_YEAR_PRIOR
        NOV_ATTENDANCE_1_YEAR_PRIOR
        DEC_ATTENDANCE_1_YEAR_PRIOR
        JAN_ATTENDANCE_1_YEAR_PRIOR
        FEB_ATTENDANCE_1_YEAR_PRIOR
        MAR_ATTENDANCE_1_YEAR_PRIOR
        APR_ATTENDANCE_1_YEAR_PRIOR
        MAY_ATTENDANCE_1_YEAR_PRIOR
        JUNE_ATTENDANCE_1_YEAR_PRIOR
        SEPT_ATTENDANCE_2_YEAR_PRIOR
        OCT_ATTENDANCE_2_YEAR_PRIOR
        NOV_ATTENDANCE_2_YEAR_PRIOR
        DEC_ATTENDANCE_2_YEAR_PRIOR
        JAN_ATTENDANCE_2_YEAR_PRIOR
        FEB_ATTENDANCE_2_YEAR_PRIOR
        MAR_ATTENDANCE_2_YEAR_PRIOR
        APR_ATTENDANCE_2_YEAR_PRIOR
        MAY_ATTENDANCE_2_YEAR_PRIOR
        JUNE_ATTENDANCE_2_YEAR_PRIOR
        PAST_10_ATT
        PAST_20_ATT
        ATTENDANCE_THIS_TERM
        ABSENCES_YTD
        SHELTER_UNIT
        SHELTER_FACILITY_NAME
        SHELTER_ADMIT_DATE
        SHELTER_ELIGIBILITY_OUTCOME
        CARES_FAMILY_ID
        HOUSING_STATUS
        TEMP_HOUSING_FLAG
        HOME_ADDRESS_PREVIOUS_TO_SHELTER
        STUDENT_NAME_FIRST_LAST
        SHELTER_OSIS_NUMBER
        CARES_ID
        SCHOOL_NAME
        CLASS
        SHELTER_GRADE
        SHELTER_AGE
        IS_SPED
        IS_ELL
        SHELTER_SCHOOL_DBN
        SCHOOL_PHONE
        ADMIT_DATE
        TRANSIT_TIME
        TRANSIT_DISTANCE
      }
    }`;
    return { query, fetchPolicy: 'no-cache' };
  }
}
